import { z } from 'zod'

import {
  capabilitySchema,
  idSchema,
  isoDateSchema,
  isoInstantSchema,
  platformRoleSchema,
  sessionTransportSchema,
  usernameSchema,
} from '../common'
import { passwordSchema } from '../auth/auth'

/**
 * Platform sign-in (§4.20).
 *
 * **No `tenantSlug`.** Platform usernames are unique among users with
 * `tenant_id IS NULL`, and the login is checked against that set only — a
 * tenant user must not be able to authenticate here by guessing a slug, and a
 * platform user has no slug to give.
 */
export const platformLoginRequest = z.object({
  username: usernameSchema,
  password: passwordSchema,
})

export const platformMeResponse = z.object({
  user: z.object({
    id: idSchema,
    name: z.string(),
    username: usernameSchema,
    role: platformRoleSchema,
  }),
  /** What the console may draw. `PLATFORM_SUPPORT` sees no billing action. */
  capabilities: z.array(z.union([capabilitySchema, z.string()])),
  today: isoDateSchema,
  maintenanceMode: z.boolean(),
})

export const platformSessionResponse = z.object({
  token: z.string().min(1).optional(),
  transport: sessionTransportSchema,
  expiresAt: isoInstantSchema,
  csrfToken: z.string().min(1).optional(),
  me: platformMeResponse,
})

export type PlatformLoginRequest = z.input<typeof platformLoginRequest>
export type PlatformMeResponse = z.infer<typeof platformMeResponse>
export type PlatformSessionResponse = z.infer<typeof platformSessionResponse>
